<template>
    <div class="admin_bar" v-show="isAdmin">
        <ul class="sub_menu_admin">
            <li class="item_admin">
                <a class="url_link" :href="props.url_admin" rel="noopener noreferrer" target="_self"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512"><path fill="currentColor" d="m326.1 231.9l-47.5 75.5a31 31 0 0 1-7 7a30.11 30.11 0 0 1-35-49l75.5-47.5a10.23 10.23 0 0 1 11.7 0a10.06 10.06 0 0 1 2.3 14"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M256 64C132.3 64 32 164.2 32 287.9a223.18 223.18 0 0 0 56.3 148.5c1.1 1.2 2.1 2.4 3.2 3.5a25.19 25.19 0 0 0 37.1-.1a173.13 173.13 0 0 1 254.8 0a25.19 25.19 0 0 0 37.1.1l3.2-3.5A223.18 223.18 0 0 0 480 287.9C480 164.2 379.7 64 256 64"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M256 128v32m160 128h-32m-256 0H96m69.49-90.51l-22.63-22.63m203.65 22.63l22.63-22.63"/></svg><p>SK Jewellery</p></a>
            </li>
            <li class="item_admin" v-if="props.title_action">
                <a class="url_link" rel="noopener noreferrer" target="_self" :href="props.url_action"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="currentColor" d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h8.925l-2 2H5v14h14v-6.95l2-2V19q0 .825-.587 1.413T19 21zm4-6v-4.25l9.175-9.175q.3-.3.675-.45t.75-.15q.4 0 .763.15t.662.45L22.425 3q.275.3.425.663T23 4.4t-.137.738t-.438.662L13.25 15zM21.025 4.4l-1.4-1.4zM11 13h1.4l5.8-5.8l-.7-.7l-.725-.7L11 11.575zm6.5-6.5l-.725-.7zl.7.7z"/></svg><p>{{ props.title_action }}</p></a>
            </li>
        </ul>
    </div>
</template>
<script setup lang="ts">
    import { ref, computed, onMounted } from "vue";
    const userStore = useUserStore();
    const isAdmin = ref(false);

    const props = defineProps({
        title_action : String,
        url_action: String,
        url_admin : String,
    });

    const redirectToBackend = (url: any) => {
        window.location.href = url;
    }

    onMounted(() => {
        if(userStore.isLogin && userStore.user?.role == 'administrator'){
            isAdmin.value = true;
        }
    })
</script>
<style lang="scss">
    .admin_bar {
        width: 100%;
        z-index: 99999;
        background: #1d2327;
        position: fixed;
        top: 0;
        height: 32px;
        display: flex;
        align-items: center;
        .sub_menu_admin {
            list-style: none;
            padding: 0;
            display: flex;
            .url_link {
                text-decoration: none;
                cursor: pointer;
                padding: 0 10px;
                color: #ffffff;
                display: flex;
                gap: 5px;
                align-items: center;
                p {
                    font-size: 13px;
                    font-weight: 400;
                    margin: 0;
                    margin-top: 2px;
                }
                &:hover {
                    color: #72aee6;
                }
            }
        }
    }
</style>